import { CardsGrid } from '@desquared/wave-components-library';
import Link from 'next/link';
import React from 'react';
import { useTranslations } from 'use-intl';

export default function Grid({ cards, columns, title, isMobile }) {
  const t = useTranslations();

  return (
    <CardsGrid
      cards={cards}
      title={title}
      columns={columns}
      isMobile={isMobile}
      LinkComponent={props => {
        return <Link prefetch={false} href={props.href} {...props} />;
      }}
    />
  );
}
